"use client";

import type React from "react";
import { usePathname } from "@/src/hooks/usePathname";
import { isInterruptiveSurfaceRoute } from "@/src/hooks/onboarding/isOnboardingRoute";

/**
 * Onboarding / welcome / pricing / login_popup 期间屏蔽会打断流程的浮层。
 * 用户进入主 app 后再恢复这些 surface。
 */
export function InterruptiveSurfaceGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  if (isInterruptiveSurfaceRoute(pathname)) {
    return null;
  }

  return <>{children}</>;
}
